import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ottimizza-mobile-center',
  templateUrl: './mobile-central-display.component.html',
  styleUrls: ['./mobile-central-display.component.scss']
})
export class MobileCentralDisplayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
